module.exports = __webpack_public_path__ + "static/media/apollo.543eac38.svg";